// style-loader: Adds some css to the DOM by adding a <style> tag
var dispose = require("!/Users/timnew/Workspace/werewolves/node_modules/bootstrap-webpack/node_modules/style-loader/addStyle.js")
	// The css code:
	(require("!!/Users/timnew/Workspace/werewolves/node_modules/bootstrap-webpack/node_modules/css-loader/index.js!/Users/timnew/Workspace/werewolves/node_modules/bootstrap-webpack/node_modules/less-loader/index.js!/Users/timnew/Workspace/werewolves/node_modules/bootstrap-webpack/bootstrap-styles.loader.js!/Users/timnew/Workspace/werewolves/node_modules/bootstrap-webpack/bootstrap.config.js"));
// Hot Module Replacement
if(module.hot) {
	module.hot.accept();
	module.hot.dispose(dispose);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-webpack/~/style-loader!./~/bootstrap-webpack/~/css-loader!./~/bootstrap-webpack/~/less-loader!./~/bootstrap-webpack/bootstrap-styles.loader.js!./~/bootstrap-webpack/bootstrap.config.js
 ** module id = 650
 ** module chunks = 0
 **/